module.exports = __webpack_public_path__ + "static/media/heroImage.ce77abc7.png";